import React from "react";
import { Stethoscope, Building2, ArrowUpRight } from "lucide-react";
import { leadership } from "../mock";
import Reveal from "./Reveal";

const iconMap = { Stethoscope, Building2 };

const Leadership = () => {
  return (
    <section id="leadership" className="bg-cream">
      <div className="max-w-5xl mx-auto px-4 py-20">
        <Reveal className="text-center mb-14">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">Beyond the Clinic</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide text-navy mt-2">Medical Leadership</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <div className="grid grid-cols-1 gap-6 max-w-xl mx-auto">
          {leadership.map((l, i) => {
            const Icon = iconMap[l.icon] || Stethoscope;
            return (
              <Reveal key={i} delay={(i % 2) + 1}>
                <div className="group h-full bg-white rounded-2xl border border-black/5 p-8 flex gap-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                  <div className="w-14 h-14 rounded-xl bg-navy flex items-center justify-center shrink-0 transition-colors group-hover:bg-gold">
                    <Icon className="w-7 h-7 text-gold transition-colors group-hover:text-navy" />
                  </div>
                  <div>
                    <div className="flex items-center gap-1 font-head text-xl uppercase tracking-wide text-navy">
                      {l.title} <ArrowUpRight className="w-4 h-4 text-gold opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                    <p className="text-[11px] font-bold tracking-widest uppercase text-gold mt-1">{l.place}</p>
                    <p className="text-sm text-gray-600 mt-2">{l.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Leadership;
